import React from 'react';
import withLayout from '../shared/hocs/layout';
import PricePlansPage from './components';

const Plans = () => <PricePlansPage />;

export default withLayout(Plans);
